import styled from 'styled-components';

const InputLike = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  position: relative;
  stroke: var(--gray-500);
  color: var(--gray-700);
  background: white;
  width: 100%;
  border: 1px solid var(--gray-300);
  border-radius: 8px;
  padding: 0.8rem 1rem;
  box-shadow: var(--box-shadow);
  transition: 0.2s;

  p {
    margin: 0;
  }

  span {
    display: flex;
    align-items: center;

    & > *:first-child {
      margin-right: 0.5rem;
    }
  }

  &:hover {
    border: 1px solid var(--gray-400);
  }
  &:focus {
    outline: 1px solid var(--gray-700);
  }
  &::placeholder {
    color: var(--gray-500);
    opacity: 1;
  }
`;
export default InputLike;
